<template lang="pug">
    include ContentPage.pug
</template>

<script>

// import _ from 'lodash'
import { mapGetters } from 'vuex'

import NestedSet from '@/nested-set-lib'
import router from '@/router'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import Post from '@/components/Post'
import PhotoAlbum from '@/components/PhotoAlbum'
import MapBox from '@/components/MapBox'

export default {
    name: 'ContentPage',
    data: () => {
        return {
            showRightPanel: false,
        }
    },
    components: {
        Heading,
        ImageSection,
        Post,
        PhotoAlbum,
        MapBox,
    },
    computed: {
        mainSections() {
            return this.sections.filter(section => {
                return section.area === 'main' && (section.key === 'heading' || section.key === 'post' || section.key === 'image')
            })
        },
        additionalSections() {
            return this.sections.filter(section => {
                return section.area === 'right'
                    && (section.key === 'image' || section.key === 'photoalbum'|| section.key === 'mapbox')
            })
        },
        ...mapGetters({
            sections: 'currentPage/sections',
            parent: 'currentPage/parent',
            menus: 'menus',
        }),
    },
    methods: {
        goUp() {
            let parent = this.parent

            const menu = this.menus.find(menu => menu.key === 'main-menu')
            const collection = _.cloneDeep(menu.menuItems);
            while (parent && parent.page && (parent.page.view === 'Folder' || parent.page.view === 'Redirect')) {
                let ancestors = NestedSet.getAncestors(collection, parent) || [];
                if (ancestors && ancestors.length) parent = ancestors[0]
                else parent = undefined
            }

            if (parent) router.push(parent.path)
            else router.push('/')
        },
    },
    mounted() {
        if (window.innerWidth >= 1088 && this.additionalSections.length) {
            setTimeout(() => {
                this.showRightPanel = true
            }, 300)
        } else {
            this.showRightPanel = true
        }
    },
    beforeRouteLeave(to, from, next) {
        if (window.innerWidth >= 1088 && this.additionalSections.length) {
            this.showRightPanel = false
            setTimeout(next, 300)
        } else {
            next()
        }
    }
}

</script>

<style lang="sass" scoped>

    @import '~@/assets/sass/variables';
    @import "~bulma/sass/utilities/mixins";

    .slide-container
        position: relative
        button.close-slide-container
            display: none
            z-index: 2
            +desktop
                display: initial
                position: absolute
                background: none
                border: 1px solid
                color: inherit
                font-size: 1rem
                top: 10px
                left: 0
                width: 20px
                height: 24px
                padding: 0
                border-radius: $radius-small
                cursor: pointer

</style>
